import {request} from '@/utils/http';

let goodsExternalList= '/fronted/goods_external/list';
let goodsExternalRecord = '/fronted/goods_external/record'


export function GET_GOODSEXTERNALLIST(params){
  return request(goodsExternalList,'get',params)
}
export function POST_GOODSEXTERNALRECORD(params){
    let headers={'Content-Type': 'application/json'}
    return request(goodsExternalRecord,'post',params,headers,false)
  }



// WEBPACK FOOTER //
// ./src/api/square.api.js